import { useTranslation } from 'react-i18next'

const T = 'replenishments.inbound_appointments.board'

// The board surfaces format numbers in the operator's UI language, not the
// browser locale (same rule the day board has used since #4229).
export const boardLocale = i18n => (i18n.language?.startsWith('pt') ? 'pt-BR' : 'es-MX')

// Per-franja capacity from the platform's inbound-franja-summary (#4229).
// reserved_units = still-booked units only (check-ins drain it): the strip is
// REMAINING BOOKABLE — the booking engine's view — not physical dock load
// (spec §3, decision 6A). Absent summary (endpoint not deployed / no entry
// for this franja) renders nothing — the header must look exactly like
// today's. Blocked wins over numbers; a zeroed-but-unblocked franja
// (dock_count_override: 0) falls through to "0 / 0 · lleno", which is true.
// ONE owner of these display rules — rendered by BOTH the day board and the
// week overview grid (eng-review D5).
export const FranjaCapacityStrip = ({ summary }) => {
  const { i18n } = useTranslation()
  if (!summary) return null
  if (summary.blocked) {
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">{i18n.t(`${T}.capacity_blocked`)}</span>
    )
  }
  const locale = boardLocale(i18n)
  const reserved = Number(summary.reserved_units ?? 0).toLocaleString(locale)
  const capacity = Number(summary.unit_capacity ?? 0).toLocaleString(locale)
  if (summary.remaining_units <= 0) {
    return <span className="text-xs font-medium text-amber-700">{`${reserved} / ${capacity} · ${i18n.t(`${T}.capacity_full`)}`}</span>
  }
  return <span className="text-xs text-gray-500">{`${reserved} / ${capacity} ${i18n.t(`${T}.capacity_reserved`)}`}</span>
}
